import { TrophyFilled } from '@ant-design/icons';
import { Badge, Space } from 'antd';
import React from 'react';
import styled from 'styled-components';
import { Avatar } from '@guuru/react-expert-avatar';

const Trophies = {
  gold: 'rgba(255, 223, 133, 0.7)',
  silver: 'rgba(180, 180, 220, 0.7)',
  bronze: 'rgba(205, 127, 50, 0.7)',
} as const;

type Trophy = keyof typeof Trophies;
const availableTrophies = Object.keys(Trophies) as Trophy[];

interface BadgeTrophyProps {
  type: Trophy;
}

const BadgeTrophy = styled.div<BadgeTrophyProps>`
  height: 24px;
  width: 24px;
  border-radius: 100%;
  background-color: #fff;
  border: ${({ type }) => `1px solid ${Trophies[type]}`};
  font-size: 16px;
  line-height: 20px;
  text-align: center;
  padding: 2px 0;

  span {
    color: ${({ type }) => Trophies[type]};
  }
`;

interface GuuruProps {
  index: number;
  expert: {
    photoUrl: string | null;
    name: string;
  };
}

const Guuru = function ({ index, expert }: GuuruProps) {
  const { photoUrl, name } = expert;
  const avatar = (
    <Avatar size="large" shape="square" src={photoUrl} text={name} />
  );
  return (
    <Space size={16}>
      {index <= 2 ? (
        <Badge
          offset={[-45, 2]}
          count={
            <BadgeTrophy type={availableTrophies[index]}>
              <TrophyFilled />
            </BadgeTrophy>
          }
        >
          {avatar}
        </Badge>
      ) : (
        avatar
      )}
      {name}
    </Space>
  );
};

export default Guuru;
